// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"629c59b2","703":"39a69bd3"}[chunkId] + ".chunk.js";
};